import { Box } from "@chakra-ui/react"



export const Footer = () =>{


return (
    <Box w={'100%'} bg={'#424242'} color={'#E0E0E0'} textAlign={'center'} p={'5px'}>
        Feedback || Privacy Policy
    </Box>
)
}